<div class="dialog email-form-wrapper">
  <!--  <ng-container *ngIf="!isMobileView">-->
  <!--    <h2 class="heading" translate>{{ isDraft ? 'Edit Draft Message' : 'New Message' }}</h2>-->
  <!--  </ng-container>-->

  <!--  <ng-container *ngIf="isMobileView && !isDraft">-->
  <!--    <div class="mobile-app-bar sticky-header">-->
  <!--      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>-->
  <!--      <h2 class="mobile-app-bar__heading">{{ (isDraft ? 'Edit Draft Message' : 'New Message') | translate }}</h2>-->
  <!--      <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>-->
  <!--    </div>-->
  <!--  </ng-container>-->

  @if (isMobileView && !isDraft) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading" translate>{{ isDraft ? 'Edit Draft Message' : 'New Message' }}</h2>
      <!--    <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Send</p>-->
    </header>
  } @else if (!isMobileView) {
    <header class="dialog__header">
      <h3 class="dialog__header__title" translate>{{ isDraft ? 'Edit Draft Message' : 'New Message' }}</h3>
      @if (!isDraft) {
        <div class="dialog__header__action-buttons">
          <div (click)="close()" class="dialog__header__action-buttons__button">
            <span>
              <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
            </span>
          </div>
        </div>
      }
    </header>
  }

  <!--  <p class="text" translate>Manage members and set their access level in your workspace</p>-->

  <div class="dialog__content">
    <form [formGroup]="form">
      <!--  Message Type  -->
      @if (!isDraft) {
        <div class="input-group --required">
          <label for="kind">{{ 'Message Type' | translate }}:</label>
          <app-dropdown name="kind" id="kind" [options]="emailTypesForForm" [placeholder]="'Message Type' | translate" bindValue="value" displayName="key" formControlName="kind"></app-dropdown>
          <app-form-error [control]="form.get('kind')" [name]="'Message Type' | translate"></app-form-error>
        </div>
      }

      <!-- TO -->
      @if (form.get('kind').value !== EmailType.GROUP) {
        <div class="input-group --required">
          <label for="toParticipants">{{ 'To' | translate }}:</label>
          <ng-select
            [clearSearchOnAdd]="true"
            [hideSelected]="true"
            [items]="teamUsers"
            [multiple]="true"
            [placeholder]="('To' | translate) + ':'"
            [searchable]="true"
            [selectOnTab]="true"
            bindLabel="fullName"
            bindValue="keycloakId"
            class="custom"
            formControlName="to"
            id="toParticipants"
          >
            <ng-template ng-footer-tmp>
              <button (click)="selectAllParticipants()" class="button button-small button-outline-primary" translate>Select all</button>
              <button (click)="unSelectAll()" class="button button-small button-simple" translate>Unselect all</button>
            </ng-template>
          </ng-select>
          <app-form-error [control]="form.get('to')" [name]="'Recipients' | translate"></app-form-error>
        </div>
      }

      <!--  Cc  -->
      @if (form.get('kind').value === EmailType.PERSONAL) {
        <div class="input-group">
          <label for="ccParticipants" translate>Cc:</label>
          <ng-select
            [clearSearchOnAdd]="true"
            [hideSelected]="true"
            [items]="teamUsers"
            [multiple]="true"
            [placeholder]="('Cc' | translate) + ':'"
            [selectOnTab]="true"
            bindLabel="fullName"
            bindValue="keycloakId"
            class="custom"
            formControlName="cc"
            id="ccParticipants"
          ></ng-select>
        </div>
      }

      <!-- Groups -->
      @if (form.get('kind').value === EmailType.GROUP) {
        <div class="input-group --required">
          <label for="group">{{ 'To' | translate }}:</label>
          <ng-select
            [clearSearchOnAdd]="true"
            [clearable]="false"
            [hideSelected]="true"
            [items]="groups"
            [multiple]="false"
            [placeholder]="('To' | translate) + ':'"
            [searchable]="true"
            bindLabel="name"
            bindValue="id"
            class="custom"
            formControlName="kindId"
            id="group"
          ></ng-select>
          <app-form-error [control]="form.get('kindId')" [name]="'Group' | translate"></app-form-error>
        </div>
      }

      <!-- Group Participants -->
      @if (form.get('kind').value === EmailType.GROUP && groupParticipants && form.get('to').value?.length) {
        <div class="input-group disabled">
          <ng-select
            [clearable]="false"
            [items]="teamUsers"
            [multiple]="true"
            [placeholder]="('To' | translate) + ':'"
            [searchable]="false"
            bindLabel="fullName"
            bindValue="keycloakId"
            class="custom"
            formControlName="to"
          ></ng-select>
        </div>
      }

      <!--  Add Subject  -->
      <div class="input-group --required">
        <label for="subject">{{ 'Subject' | translate }}:</label>
        <input [placeholder]="'Add a subject...' | translate" formControlName="subject" id="subject" name="subject" type="text" />
        <app-form-error [control]="form.get('subject')" [name]="'Subject' | translate"></app-form-error>
      </div>

      <!-- Upload Files-->
      <!--    <div class="input-group">-->
      <!--      <label for="file" translate>Choose File</label>-->
      <!--      <input (change)="handleFileInput($event.target.files)" formControlName="file" id="file" type="file" pla />-->
      <!--    </div>-->

      <!-- Choose File -->
      <app-file-selector-input (attachmentSelected)="selectedAttachment = $event" [accept]="acceptFileTypes"></app-file-selector-input>
      <!--    <div class="input-group">-->
      <!--      <div class="file-selector-input">-->
      <!--        <input (change)="handleFileInput($event.target.files)" [placeholder]="selectedAttachment ? selectedAttachment.name : ('No file chosen' | translate)" hidden id="file-selector" type="file" />-->

      <!--        <label [class.selected]="selectedAttachment" for="file-selector">-->
      <!--          <span>-->
      <!--            <app-icon [color]="selectedAttachment ? 'var(&#45;&#45;white)' : 'var(&#45;&#45;text-color-dark)'" iconName="paper-clip" marginBottom="-5px"></app-icon>-->
      <!--            {{ selectedAttachment ? selectedAttachment.name : ('Choose File' | translate) }}-->
      <!--          </span>-->
      <!--          <ng-container *ngIf="selectedAttachment">-->
      <!--            <app-icon (click)="$event.preventDefault(); $event.stopPropagation(); selectedAttachment = null" color="var(&#45;&#45;white)" iconName="close" marginBottom="-5px"></app-icon>-->
      <!--          </ng-container>-->
      <!--        </label>-->
      <!--      </div>-->
      <!--    </div>-->

      <!--  Add Message  -->
      <div class="input-group --required">
        <label for="content">{{ 'Message' | translate }}:</label>
        <textarea [placeholder]="'Type a message...' | translate" formControlName="content" id="content" rows="4"></textarea>
        <app-form-error [control]="form.get('content')" [name]="'Message' | translate"></app-form-error>
      </div>
    </form>
  </div>

  <!-- Buttons -->
  <div class="buttons-container">
    @if (!isDraft) {
      <app-button
        (clickEvent)="sendMessage($event, true)"
        [cssClass]="isMobileView ? 'button-simple' : 'button-primary'"
        [disabled]="loadings.teamUsers || loadings.groups"
        [idleText]="'Draft' | translate"
      ></app-button>
    }
    <div class="button-group">
      @if (!isDraft && !isMobileView) {
        <app-button (click)="close()" [disabled]="loadings.teamUsers || loadings.groups" [idleText]="'Cancel' | translate" cssClass="button"></app-button>
      }
      <app-button (clickEvent)="sendMessage($event)" [disabled]="loadings.teamUsers || loadings.groups" [idleText]="'Send' | translate" class="" cssClass="button-primary"></app-button>
    </div>
  </div>
</div>
